import { Component, inject } from '@angular/core';
import { BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { ConfirmDialogContext } from './confirmation-dialog.interfaces';

@Component({
  selector: 'finxone-web-frontend-confirmation-dialog',
  standalone: false,
  templateUrl: './confirmation-dialog.component.html',
})
export class ConfirmDialogComponent {
  private readonly _dialogRef = inject<BrnDialogRef<boolean>>(BrnDialogRef);
  private readonly configService = inject(ConfigService);
  protected readonly dialogCtx = injectBrnDialogContext<ConfirmDialogContext>();

  protected get positiveButtonClass(): string {
    return this.getCssVariableValue('--confirmDialogPositiveButtonClass') || 'primaryButton small';
  }
  protected get negativeButtonClass(): string {
    return this.getCssVariableValue('--confirmDialogNegativeButtonClass') || 'secondaryButton small';
  }

  confirm(): void {
    this._dialogRef.close(true);
  }

  cancel(): void {
    this._dialogRef.close(false);
  }

  private getCssVariableValue(variableName: string): string {
    const globalCssVariables = this.configService?.globalCssVariables()?.[variableName];
    if (globalCssVariables?.trim()) {
      return globalCssVariables.trim();
    }
    return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
  }
}
